import React from 'react';
import cx from 'classnames';
import { GOOGLE_ICON } from '../constants/assetConstants';

export const ContinueWithGoogle = ({
  text = 'Continue with Google',
  onClick = null,
  btnClassName = '',
  containerClassName = '',
  containerStyle = {},
  buttonStyle = {},
}) => {
  return (
    <div
      className={cx('google-login d-flex justify-content-center', containerClassName)}
      style={containerStyle}>
      <button
        className={cx('btn bg-body py-2 position-relative google-btn w-100', btnClassName)}
        onClick={onClick}
        style={buttonStyle}>
        <img src={GOOGLE_ICON} width={22} height={22} />
        <span className="google-text">{text}</span>
      </button>
    </div>
  );
};
